import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function WeInNumberColumns() {
    return (
        <>
            <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                نحن في أرقام
            </div>
            <div className="mt-8 w-full text-lg text-right text-zinc-900 max-md:max-w-full">
                مؤسسة الخير تفتخر بتحقيق إنجازات واضحة من خلال التفاني والجهود المستدامة
                في سبيل تحقيق أهدافها الإنسانية، وتسعى باستمرار لتوسيع تأثيرها الإيجابي
                وتقديم الدعم في الأوقات الطارئة، مع التركيز الدائم على الشفافية
                والمساءلة.
            </div>
            <div className="flex flex-col p-11 mt-10 w-full font-bold text-center whitespace-nowrap bg-white rounded-2xl border-b-2 border-solid border-b-zinc-300 border-b-opacity-80 max-md:px-5 max-md:max-w-full">
                <div className='flex flex-col border-solid border-[#BDBDBD] border-2 rounded-lg'>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-0 justify-center max-md:flex-wrap max-md:max-w-full *:border-b-2 *:border-l-2">
                        <div className="flex flex-col flex-1 p-6  max-md:px-5  first:border-l-2 first:border-b-2">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/96749b981d0316f041087db0aa2bee9842d4025f581fb5dca88fa4268b727072?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-12 mt-4 max-md:px-5">
                                <div className="text-lg leading-7 text-zinc-600">بناء مسجد</div>
                                <div className="self-center mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    400
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/9c401694a20db2558b4d86772baefad4160d4c90e833bb09e866aa327c352c91?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-12 mt-4 max-md:px-5">
                                <div className="text-lg leading-7 text-zinc-600">طرد غذائي</div>
                                <div className="mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    27,000
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 items-center p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/df4546df8b9d84122d1547894527b16f80781c73735349a6ed5da15cd77b1756?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="aspect-square w-[60px]"
                            />
                            <div className="self-stretch mt-4 text-lg leading-7 text-zinc-600">
                                عمليات جراحية
                            </div>
                            <div className="mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                135
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/7db2653fa2bb6005cfd7763a3fca7cb4ef50b1053f3d6ddfa8d216995a33586d?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-3.5 mt-4">
                                <div className="text-lg leading-7 text-zinc-600">
                                    تعليم طفل في المداس
                                </div>
                                <div className="self-center mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    6,000
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/243b671f33959597670ca08ff14af098ea95e4febf61dc46f9f4d382736ec342?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-7 mt-4 max-md:px-5">
                                <div className="text-lg leading-7 text-zinc-600">
                                    كفالة يتيم وأرملة
                                </div>
                                <div className="self-center mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    2,000
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-0 justify-center max-md:flex-wrap max-md:max-w-full *:border-l-2">
                        <div className="flex flex-col flex-1 p-6  max-md:px-5  first:border-l-2">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/96749b981d0316f041087db0aa2bee9842d4025f581fb5dca88fa4268b727072?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-12 mt-4 max-md:px-5">
                                <div className="text-lg leading-7 text-zinc-600">بناء مسجد</div>
                                <div className="self-center mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    400
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/9c401694a20db2558b4d86772baefad4160d4c90e833bb09e866aa327c352c91?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-12 mt-4 max-md:px-5">
                                <div className="text-lg leading-7 text-zinc-600">طرد غذائي</div>
                                <div className="mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    27,000
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 items-center p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/df4546df8b9d84122d1547894527b16f80781c73735349a6ed5da15cd77b1756?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="aspect-square w-[60px]"
                            />
                            <div className="self-stretch mt-4 text-lg leading-7 text-zinc-600">
                                عمليات جراحية
                            </div>
                            <div className="mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                135
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/7db2653fa2bb6005cfd7763a3fca7cb4ef50b1053f3d6ddfa8d216995a33586d?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-3.5 mt-4">
                                <div className="text-lg leading-7 text-zinc-600">
                                    تعليم طفل في المداس
                                </div>
                                <div className="self-center mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    6,000
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 p-6  max-md:px-5">
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/243b671f33959597670ca08ff14af098ea95e4febf61dc46f9f4d382736ec342?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                className="self-center aspect-square w-[60px]"
                            />
                            <div className="flex flex-col px-7 mt-4 max-md:px-5">
                                <div className="text-lg leading-7 text-zinc-600">
                                    كفالة يتيم وأرملة
                                </div>
                                <div className="self-center mt-2 text-xl tracking-wide leading-7 text-zinc-800">
                                    2,000
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WeInNumberColumns